import React from "react";
import "../styles/youtubevideos.css";
const YoutubeVideos = () => {
  return (
    <div className="youtube-video">
      <iframe
        width="560"
        height="100%"
        src="https://www.youtube.com/embed/mEVaHn4HsFM?si=wTUg5gdksgWhuIrT"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  );
};

export default YoutubeVideos;
